<script setup lang="ts">
definePageMeta({
  custom_meta_data: {
    topic: 'integrasi',
    message: 'Saya tertarik dengan integrasi API KiriminAja'
  }
})

const route = useRoute()

const { data } = await useAsyncData(`integration-${route.path}`, () =>
  queryCollection('integration')
    .path(`/integration/${route.params.slug?.toString()}`)
    .first()
)

if (!data.value || !route.params.slug) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page not found'
  })
}

const courier = computed(() =>
  getCourierProps(route.params.slug?.toString() || '')
)

useDefaultMeta({
  title: data.value?.meta?.title || data.value.title,
  description: data.value.meta?.description || data.value.description,
  robots: 'index, follow',
  schema: {
    type: ['SoftwareApplication', 'WebApplication'],
    breadcrumbs: [
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Integrasi API',
        item: appUrl('/integration')
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: courier.value?.courier || 'Integrasi API',
        item: appUrl(route.fullPath)
      }
    ]
  }
})

const highlightedItems = [
  {
    title: '99.95% API Uptime',
    icon: 'material-symbols:trending-up'
  },
  {
    title: '50+ Juta Webhook & Tracking per bulan',
    icon: 'material-symbols:track-changes'
  },
  {
    title: '18+ Kurir Terintegrasi',
    icon: 'material-symbols:local-shipping-outline'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      :title="data?.title"
      :description="data?.description"
      hero-image="/images/integration-api-banner-1.webp"
    >
      <template v-if="courier" #above-title>
        <div class="flex gap-3 items-center">
          <UiCourierService
            class="h-6 aspect-video"
            :icon="courier?.icon"
            icon-size="40px"
            :class="courier.class"
          />
          <div class="grow font-semibold">
            {{ courier.courier }}
          </div>
        </div>
      </template>
      <template #action>
        <div class="flex items-center gap-2 lg:gap-4 py-2">
          <UiButton
            :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
            label="Dapatkan Demo"
            variant="primaryOutline"
          />
          <UiButton
            :to="$utm.utmUrl('https://developer.kiriminaja.com')"
            label="Lihat Dokumen API"
            target="_blank"
          />
        </div>
        <div
          class="flex flex-col lg:flex-row lg:items-center gap-4 lg:flex-wrap"
        >
          <UiCardFeature
            v-for="(item, key) in highlightedItems"
            :key="key"
            class="bg-surface-container"
            wrapper-class="bg-surface-container flex-row items-center p-3"
            title-class="text-sm lg:text-sm"
            icon-wrapper-class="bg-background"
            :icon="item.icon"
            icon-size="24px"
            :title="item.title"
          />
        </div>
      </template>
    </HeroBase>

    <OtherIntegrationTanpaIntegrasi
      :title="data?.pain_point?.title"
      :items="data?.pain_point?.items"
    />
    <OtherIntegrationFeatures
      :title="data?.feature.title"
      :description="data?.feature.description"
      :items="data?.feature.items ?? []"
    />
    <OtherIntegrationWorkflow
      :title="data?.workflow.title"
      :items="data?.workflow.steps"
    />
    <OtherIntegrationBenefit
      :title="data?.benefit.title"
      :items="data?.benefit.items"
    />
    <PresetCourier
      title="Semua Ekspedisi Favoritmu"
      path="/integration"
      with-instant-courier
    />
    <FaqBase :title="data?.faq?.title" :faqs="data?.faq?.items ?? []" />
    <OtherIntegrationCta
      :title="data?.cta.title"
      :description="data?.cta.description"
    />
  </div>
</template>
